export default "__VITE_ASSET__D51$_1hk__"